// extracted by mini-css-extract-plugin
export default {"redDabi":"#004594","secondaryRedDabi":"#c4c4c4","redDabiHover":"rgba(241,36,36,.3568627451)","redInv":"#f8463b","greenInv":"#52b442","robotoRegular":"RobotoCondensedRegular"};